import parseStoryBoardUrl from '../parseStoryBoardUrl/parseStoryBoardUrl.js';

export default class AuthTypes {
	static getEmailHash() {
		//matches anything that has /bar/somehashhere/whatever
		// Also matches /bar/somehashhere hence the reason for the .split('/')
		const emailHash = window.location.href.match(/\/bar\/([^?#]*)(\/)?/);
		const parentEmailHash = window.parent.location.href.match(/\/bar\/([^?#]*)(\/)?/);
		return emailHash || parentEmailHash || undefined;
	}

	static getBoardHash() {
		const parsed = parseStoryBoardUrl(window.location.href);
		if (!parsed || parsed.access === 'private') {
			return undefined;
		}
		return parsed.hash;
	}

	static getJwt() {
		if (window.location.search.match(/(\?|&)anonymous\b/)) {
			return undefined;
		}
		let jwt = localStorage.getItem('jwt');
		if (jwt) {
			try {
				jwt = JSON.parse(jwt);
			} catch (e) {
				//nothing to do if we couldn't parse the jwt
			}
		}
		if (jwt && jwt.token && jwt.payload && jwt.payload.exp > +new Date() / 1000) {
			return jwt.token;
		}
		return undefined;
	}

	static isPublic(url) {
		return /(\/auth\/type|\/auth\/login|\/auth\/is_remembered|\/ulog\/write)$/.test(url);
	}

	static getHeader(url = '') {
		let auth;
		if (AuthTypes.isPublic(url)) {
			return 'Public';
		}
		if ((auth = AuthTypes.getEmailHash())) {
			return `Email ${auth}`;
		}
		if ((auth = AuthTypes.getJwt())) {
			return `Bearer ${auth}`;
		}
		if ((auth = AuthTypes.getBoardHash())) {
			return `Board ${auth}`;
		}
		return undefined;
	}

	static getUrlParam(url) {
		const auth = AuthTypes.getHeader(url);
		if (auth) {
			return 'addHeaders=' + encodeURIComponent(JSON.stringify({ Authorization: auth }));
		}
		return '';
	}

	static isLoggedIn() {
		return AuthTypes.getHeader() !== undefined;
	}
}
